import type { Dict } from './en';

/** Uzbek (partial; missing keys fall back to English). */
export const uz: Partial<Dict> = {
  'auto.typePlaceholder': 'Tashrif buyuruvchi nomidan yozing…',
  'auto.typeSend': 'Yuborish',
  'auto.typedBy': '{by} yozdi',
  'auto.operator': 'operator',
  'common.close': "Yopish",
  'common.cancel': "Bekor qilish",
  'maps.noRobotOnline': "Tarmoqda robotlar yo‘q",
  'maps.pullFailed': "Yuklab bo‘lmadi",
  'maps.pulled': "«{name}» yuklandi",
  'maps.pulling': "Yuklanmoqda…",
  'maps.pull': "Robotdan yuklash",
  'maps.current': "joriy",
  'maps.robotMap': "Robotdagi xarita",
  'maps.listMaps': "Xaritalar ro‘yxati",
  'maps.robot': "Robot",
  'maps.pullTitle': "Robotdan xaritani yuklash",
  'fab.wheelsReleased': "G‘ildiraklar bo‘shatilgan",
  'fab.switchFor': "{name} uchun qo‘lda surish",
  'fab.chipEstop': "Favqulodda",
  'fab.chipIdle': "Bo‘sh",
  'fab.chipLocking': "Qulflanmoqda…",
  'fab.chipReleasing': "Bo‘shatilmoqda…",
  'fab.lockAll': "Barcha g‘ildiraklarni qulflash",
  'fab.noneOnline': "Tarmoqda robotlar yo‘q",
  'fab.popHint': "Xodim robotni qo‘lda surishi uchun g‘ildirak tormozlarini bo‘shatadi. G‘ildiraklarni qayta qulflash uchun o‘chiring.",
  'fab.summaryN': "{n} ta robot qo‘lda surish rejimida",
  'fab.summaryOne': "{n} ta robot qo‘lda surish rejimida",
  'fab.lockN': "G‘ildiraklarni qulflash · {n} ta robot",
  'fab.handPushName': "Qo‘lda surish · {name}",
  'fab.lockName': "G‘ildiraklarni qulflash · {name}",
  'fab.charging': "Qo‘lda surish · robot quvvatlanmoqda",
  'fab.offline': "Qo‘lda surish · robot tarmoqda emas",
  'fab.locking': "G‘ildiraklar qulflanmoqda · {name}",
  'fab.releasingShort': "G‘ildiraklar bo‘shatilmoqda…",
  'fab.lockingShort': "G‘ildiraklar qulflanmoqda…",
  'fab.chargingShort': "Qo‘lda surish · quvvatlanmoqda",
  'fab.offlineShort': "Qo‘lda surish · tarmoqda emas",
  'fab.releasing': "G‘ildiraklar bo‘shatilmoqda · {name}",
  'hand.retry': "Qayta urinish",
  'pull.keepOpen': "Katta skanerlar Wi-Fi orqali bir necha daqiqa davom etadi; oynani yopmang.",
  'pull.mb': "{a} MB",
  'pull.mbOf': "{a} / {b} MB",
  'pull.stage.working': "Bajarilmoqda…",
  'pull.stage.uploading': "Serverga yuklanmoqda",
  'pull.stage.downloading': "Robot xaritani yig‘moqda",
  'pull.stage.asking': "Robotga so‘rov…",
  'pull.pullingName': "«{name}» yuklanmoqda…",
  'pull.copies': "«{name}» serverga nusxalanadi",
  'pull.replaces': "Serverdagi «{name}» nusxasi almashtiriladi",
  'pull.converts': "«{name}» navigatsiya xaritasiga aylantiriladi",
  'pull.selectOne': "Yuklash uchun xaritani tanlang",
  'pull.waiting': "Robot javobi kutilmoqda",
  'pull.hint': "U-SCAN xaritalari robotning skanerlash ilovasidan olinadi; yuklashda ular navigatsiya xaritasiga aylantiriladi",
  'pull.today': "bugun, {time}",
  'pull.modified': "o‘zgartirilgan {when}",
  'pull.onServer': "serverda bor",
  'pull.uscanError': "U-SCAN xaritalarini o‘qib bo‘lmadi: {error}",
  'pull.noUscanHint': "Robotdagi U-SCAN ilovasida hududni skanerlang, so‘ng ro‘yxatni yangilang.",
  'pull.noUscan': "Bu robotda U-SCAN xaritalari yo‘q",
  'pull.noSdk': "Bu robotda navigatsiya xaritalari yo‘q",
  'pull.mapsN': "{n} ta xarita",
  'pull.mapsOne': "{n} ta xarita",
  'pull.scanningApp': "skanerlash ilovasi",
  'pull.secSdk': "Navigatsiya (SDK)",
  'pull.retry': "Qayta urinish",
  'pull.refresh': "Xaritalar ro‘yxatini yangilash",
  'pull.countOn': "{robot} da {n} ta",
  'pull.listingOn': "{robot} xaritalari so‘ralmoqda… avval navigatsiya, keyin U-SCAN",
  'pull.listing': "yuklanmoqda…",
  'pull.pickRobot': "Onlayn robotni tanlang",
  'pull.robotOffline': "{robot} tarmoqda emas: xaritalarni faqat onlayn robotdan ko‘rish mumkin",
  'pull.offline': "Robot tarmoqda emas",
  'pull.offlineShort': "oflayn",
  'pull.online': "onlayn",
  'clog.appHint': "Robot ilovasi logining oxiri. «Yuklash» ni bosing: server uni robotdan so‘raydi.",
  'clog.noLines': "(mos qatorlar yo‘q)",
  'clog.lines': "Qatorlar",
  'clog.grep': "grep…",
  'clog.empty': "Qatorlar yo‘q",
  'clog.apiMissing': "Bu jurnal uchun yangiroq server kerak",
  'clog.data': "Ma’lumotlar",
  'clog.args': "Argumentlar",
  'clog.error': "xato",
  'clog.colArgs': "Argumentlar / ma’lumotlar",
  'clog.colDuration': "Davomiyligi",
  'clog.colResult': "Natija",
  'clog.colSource': "Manba",
  'clog.colName': "Buyruq / hodisa",
  'clog.colTime': "Vaqt",
  'clog.load': "Yuklash",
  'clog.refresh': "Yangilash",
  'clog.rowsN': "{n} qator",
  'clog.nameFilter': "Nomi bo‘yicha filtr…",
  'clog.events': "Hodisalar",
  'clog.cmds': "Buyruqlar",
  'clog.all': "Barchasi",
  'clog.kind': "Tur",
  'clog.tab.app': "Robot ilovasi logi",
  'clog.tab.cmd': "Buyruqlar jurnali",
  'clog.tab.events': "Hodisalar",
  'clog.logs': "Jurnallar",
  'hist.deleteLive': "Davom etayotgan suhbatni o‘chirib bo‘lmaydi",
  'hist.deleteFailed': "Suhbatni o‘chirib bo‘lmadi",
  'hist.deleted': "Suhbat o‘chirildi",
  'hist.deleteConfirm': "Bu suhbatni butunlay o‘chirasizmi?",
  'hist.exportFailed': "Eksport qilib bo‘lmadi",
  'hist.loadEarlier': "Oldingi xabarlarni yuklash",
  'hist.go': "O‘tish",
  'hist.jump': "O‘tish",
  'hist.toolsN': "{n} asbob chaqiruvi",
  'hist.turnsN': "{n} navbat",
  'hist.session': "Suhbat",
  'hist.more': "Yana ko‘rsatish",
  'hist.empty': "Bu shartlarga mos suhbatlar yo‘q",
  'hist.apiMissing': "Suhbatlar tarixi uchun yangiroq server kerak",
  'hist.end.error': "xato",
  'hist.end.schedule': "jadval oynasi yopildi",
  'hist.end.estop': "favqulodda to‘xtatish",
  'hist.end.ended': "tugadi",
  'hist.end.battery': "batareya kam",
  'hist.end.timeout': "sukut",
  'hist.end.stopped': "operator to‘xtatdi",
  'hist.live': "jonli",
  'hist.colPreview': "Birinchi so‘z",
  'hist.colEnd': "Yakun",
  'hist.colTools': "Asboblar",
  'hist.colTurns': "Navbatlar",
  'hist.colDuration': "Davomiyligi",
  'hist.colProfile': "Profil",
  'hist.colRobot': "Robot",
  'hist.colWhen': "Qachon",
  'hist.clearFilters': "Filtrlarni tozalash",
  'hist.to': "gacha",
  'hist.from': "dan",
  'hist.allProfiles': "Barcha profillar",
  'hist.allRobots': "Barcha robotlar",
  'hist.profile': "Profil",
  'hist.robot': "Robot",
  'hist.search': "Suhbatlarda qidirish…",
  'hist.countN': "{n} ta suhbat",
  'hist.linkTitle': "Bu robotning oldingi avtonomiya suhbatlarini ko‘rish",
  'hist.link': "Suhbatlar tarixi",
  'hist.tabHistory': "Tarix",
  'hist.tabProfiles': "Profillar",
  'hist.title': "Avtonomiya tarixi",
  'facing.warn': "Yo‘nalishsiz nuqtalar: {n}",
  'facing.flipTitle': "180° ga burish (quvvatlash nuqtasi uchun: Cruzr orqasi bilan ulanadi, kontaktlar orqada)",
  'facing.lookHint': "«{name}» nuqtasi qarashi kerak bo‘lgan joyga xaritada bosing",
  'facing.lookTitle': "So‘ng xaritada odam yoki eksponat turgan joyga bosing: nuqta o‘sha tomonga buriladi",
  'facing.look': "Shu yerga qarash",
  'facing.count': "{n} ta yo‘nalishsiz",
  'facing.unsetHint': "robot kelib, tasodifiy tomonga qaraydi; strelkani torting, gradus kiriting yoki «Shu yerga qarash» ni bosing",
  'facing.unsetShort': "yo‘nalish yo‘q",
  'facing.unset': "yo‘nalish belgilanmagan",
  'mapRobots.toggle': "Tafsilotlarni ko‘rsatish / yashirish",
  'mapRobots.notLocatedHint': "robot bu xaritada qayerdaligini bilmaydi",
  'mapRobots.chipOtherMap': "xarita {name}",
  'mapRobots.chipCharging': "quvvatda",
  'auto.state.idle': "kutish",
  'auto.state.paused': "pauza",
  'auto.state.moving': "harakatlanmoqda",
  'auto.state.speaking': "gapirmoqda",
  'auto.state.thinking': "o‘ylamoqda",
  'auto.state.listening': "tinglamoqda",
  'hand.whyUnknown': "noma’lum xato",
  'hand.failReleaseSilent': "G‘ildiraklarni bo‘shatib bo‘lmadi · {name} javob bermadi",
  'hand.failLockSilent': "G‘ildiraklarni qulflab bo‘lmadi · {name} javob bermadi — «To‘xtatish» yoki robotdagi favqulodda tugmani bosing",
  'hand.failRelease': "G‘ildiraklarni bo‘shatib bo‘lmadi · {name}: {why}",
  'hand.failLock': "G‘ildiraklarni qulflab bo‘lmadi · {name}: {why} — «To‘xtatish» yoki robotdagi favqulodda tugmani bosing",
  'hand.whyCharging': "robot quvvatlanmoqda",
  'hand.whyEstop': "favqulodda to‘xtatish bosilgan",
  'hand.whyUnsupported': "robot ilovasi buni hali qo‘llamaydi",
  'mode.stopTitle': "Joriy vazifani to‘xtatish",
  'mode.stopShort': "To‘xtatish",
  'mode.exitHandPush': "Qo‘lda surishdan chiqish: g‘ildiraklarni qulflash",
  'mode.lockShort': "Qulflash",
  'mode.task': "Vazifa: {task}",
  'mode.navTo': "Navigatsiya → {point}",
  'mode.navigation': "Navigatsiya",
  'mode.tour': "Tur",
  'mode.autonomy': "Avtonomiya",
  'mode.chargeFailed': "Quvvatlashga yeta olmadi",
  'mode.goingCharge': "Quvvatlashga ketmoqda",
  'mode.charging': "Quvvatlanmoqda",
  'mode.stuckFailed': "Qotib qoldi · yordam kerak",
  'mode.stuck': "Qotib qoldi",
  'mode.handPush': "Qo‘lda surish",
  'mode.estopHint': "Robot orqasidagi qizil tugmani bo‘shating",
  'mode.estop': "Favqulodda to‘xtatish",
  'mode.normal': "Oddiy",
  'cal.mirrorNotSupported': "Server hali cameraMirrored qabul qilmaydi; teskarilik faqat shu konsolda tuzatiladi.",
  'cal.pushMirror': "Robotga ham xabar berish (cameraMirrored), u yo‘nalishni o‘zi to‘g‘rilaydi",
  'cal.mirrorUnclear': "teskarilik aniq emas (chaproq turing)",
  'cal.mirrorNo': "chap/o‘ng to‘g‘ri",
  'cal.mirrorYes': "chap/o‘ng TESKARI",
  'cal.camScale': "masofa × {s}",
  'cal.camSkipped': "tekshirilmadi",
  'cal.camera': "Kamera",
  'cal.skip': "O‘tkazib yuborish",
  'cal.camTooFew': "Yuzli kadrlar faqat {n}; robotga qarab qayta yozing.",
  'cal.camGot': "yuzli kadrlar: {n} · median {d} m, {b}° (+ = chap)",
  'cal.camStarting': "Kamera ochilmoqda… robot uni uzatishni boshlagach odamlarni aniqlash boshlanadi.",
  'cal.camNoSupport': "Bu robot kameradagi odamlarni yubormaydi (eski ilova).",
  'cal.step.camera': "Ixtiyoriy: robot oldida 1 m masofada, taxminan 30 sm ROBOTNING CHAP tomonida, unga qarab turing (kamera yuzlarni ko‘radi). 10 s yozib oling. Bu kamera masofa masshtabini va chap/o‘ng almashinmaganini tekshiradi.",
  'cal.short.camera': "Kamera 1 m (ixtiyoriy)",
  'sens.srcPeopleOff': "Kamera yuzlari · o‘chiq (kamera ochilmagan)",
  'sens.srcPeople': "Kamera yuzlari · hozir {n} · ko‘rish {fov}°",
  'sens.colSource': "Manba",
  'sens.camWatching': "Kamera ochiq",
  'sens.camOpen': "Kamerani ochish",
  'sens.camOffTitle': "Kameradagi odamlar: o‘chiq",
  'sens.camHint': "Kameradagi odamlar robot kamerasi ochiq bo‘lganda ishlaydi",
  'sens.camLayerTitle': "Bosh kamerasidagi yuzlar (old tomondan, ~0.4–2.5 m) va kamera ko‘rish maydoni",
  'sens.capPeople': "{p} odam · {n} yaqinlashmoqda · eng yaqini {d}",
  'sens.src.fused': "kamera + chuqurlik",
  'sens.src.camera': "kamera",
  'sens.src.depth': "chuqurlik",
  'sens.person': "Odam",
  'cal.reset': "Kalibrlash o‘chirildi",
  'cal.resetConfirm': "Shu robotning datchik kalibrlashini o‘chirasizmi?",
  'cal.resetBtn': "Tiklash",
  'cal.current': "Joriy: {at} · tartib {order} · masshtab ×{scale}",
  'cal.savedLocal': "Kalibrlash shu brauzerda saqlandi (server hali saqlamaydi)",
  'cal.savedServer': "Kalibrlash shu robot uchun saqlandi",
  'cal.save': "Kalibrlashni saqlash",
  'cal.again': "Qaytadan",
  'cal.ignoreNote': "Miltillash qiymatlari (faqat 5 tadan 4 tasida hisoblanadi): {list}",
  'cal.noise': "Bo‘sh joydagi shovqin (sektorlar)",
  'cal.scale': "Masofa masshtabi",
  'cal.unclear': "aniq emas (standart qoldirildi)",
  'cal.rtl': "o‘ngdan → chapga (teskari)",
  'cal.ltr': "chapdan → o‘ngga",
  'cal.order': "Sektorlar tartibi",
  'cal.finish': "Tugatish",
  'cal.next': "Keyingi",
  'cal.redo': "Qayta yozish",
  'cal.start': "10 s yozish",
  'cal.back': "Orqaga",
  'cal.noData': "Robotdan yangi chuqurlik ma’lumoti yo‘q.",
  'cal.tooFew': "Kadrlar juda kam; robot chuqurlik ma’lumotini yuborayotganini tekshirib, qayta yozing.",
  'cal.nearShare': "Sektorlar bo‘yicha yaqin qiymatlar",
  'cal.got': "{n} kadr yozildi · sektorlar bo‘yicha «yaqin» qiymatlar ulushi:",
  'cal.recording': "Yozilmoqda… {s} s · {n} kadr",
  'cal.passive': "Robot harakatlanmaydi; faqat u allaqachon yuborayotgan chuqurlik ma’lumotlari yoziladi.",
  'cal.step.right': "Endi 0.5 m oldinda, eng O‘NG chetda (robotning o‘ng tomoni). 10 s yozib oling.",
  'cal.step.left': "Endi 0.5 m oldinda, ko‘rish maydonining eng CHAP chetida (robotning chap tomoni). 10 s yozib oling.",
  'cal.step.centre': "Robot oldida, markazda 0.5 m masofada turing (yoki quti qo‘ying). Qimirlamang va 10 s yozib oling.",
  'cal.step.empty': "Robot oldidagi joyni bo‘shating: 1.5 m ichida hech narsa bo‘lmasin (odamlar chetga chiqsin). So‘ng 10 s yozib oling. Bo‘sh joyda miltillovchi qiymatlar har bir sektor shovqini sifatida eslab qolinadi.",
  'cal.short.right': "0.5 m o‘ngda",
  'cal.short.left': "0.5 m chapda",
  'cal.short.centre': "0.5 m markazda",
  'cal.short.empty': "Bo‘sh joy",
  'cal.steps': "Qadamlar",
  'cal.notCalibrated': "kalibrlanmagan",
  'cal.button': "Kalibrlash",
  'cal.title': "Datchiklarni kalibrlash",
  'sens.far': "uzoq",
  'sens.chipLow': "Ishonchsiz",
  'sens.chipNoisy': "Shovqin",
  'sens.rawFilteredTitle': "Oxirgi xom qiymat | filtrlangan (sm): oxirgi 5 tasidan mos keluvchilarning medianasi",
  'sens.colRawFiltered': "Xom | filtr",
  'sens.lgClear': "≥ {d} = bo‘sh",
  'sens.ageMin': "{m} daq oldin",
  'sens.ageNow': "{s} s oldin",
  'sens.ageS': "{s} s oldin",
  'sens.alApproach': "Nimadir yaqinlashmoqda",
  'sens.alApproachDesc': "{id} · {d} {side} · {v} m/s · ≈{ttc} s da to‘qnashuv",
  'sens.alCliff': "Jarlik aniqlandi · harakat bloklangan",
  'sens.alCliffDesc': "SDK cliff hodisasi (ha/yo‘q, joylashuvsiz) · robotni ROS to‘xtatdi",
  'sens.alEstop': "Favqulodda to‘xtatish bosilgan",
  'sens.alEstopDesc': "Qayta yurish uchun robot orqasidagi tugmani bo‘shating",
  'sens.alInside': "Xavfli yaqinlashish · {d} ichida",
  'sens.alNone': "Ogohlantirishlar yo‘q",
  'sens.alNoneDesc': "{d} ichida hech narsa yaqinlashmayapti",
  'sens.alObstacle': "SDK obstacle hodisasi",
  'sens.alObstacleDesc': "Navigatsiya oldinda to‘siq borligini bildiradi · ROS harakatni to‘xtatdi",
  'sens.alSectorNd': "Chuqurlik sektori {n} · ma’lumot yo‘q",
  'sens.alSectorNdDesc': "Sektor 0 qaytarmoqda · ehtimol, yorug‘lik aksi yoki diapazondan tashqari",
  'sens.alSkin': "E-skin tegildi · {z}",
  'sens.alSkinDesc': "Kimdir robot qo‘liga tegmoqda",
  'sens.alTooClose': "Juda yaqin",
  'sens.alTooCloseDesc': "Robot oldida {d} masofada nimadir bor",
  'sens.alertAt': "Ogohlantirish masofasi <",
  'sens.alerts': "Ogohlantirishlar",
  'sens.blindRear': "masofa ma’lumoti yo‘q (faqat robot navigatsiyasi)",
  'sens.blindSide': "masofa ma’lumoti yo‘q",
  'sens.camSoonTitle': "Kameradagi odamlar — tez orada (serverda hali kamera aniqlashlari yo‘q)",
  'sens.capCharging': "Quvvatlanmoqda · datchiklar kutishda",
  'sens.capCliff': "Jarlik · harakat bloklangan",
  'sens.capNoSensors': "Datchik ma’lumotlari yo‘q",
  'sens.capStale': "Chuqurlik ma’lumotlari eskirgan",
  'sens.capSummary': "{n} yaqinlashmoqda · eng yaqini {d}",
  'sens.chargingDesc': "Kuzatuv to‘xtatilgan · chuqurlik ~1 Hz da kelmoqda",
  'sens.chipClear': "Bo‘sh",
  'sens.chipNoData': "Ma’lumot yo‘q",
  'sens.clear': "bo‘sh",
  'sens.clearBeyond': "undan narisi bo‘sh",
  'sens.cliff': "Jarlik",
  'sens.cliffBadge': "Jarlik · SDK joylashuv bermaydi",
  'sens.colBearing': "Yo‘nalish",
  'sens.colDist': "Masofa",
  'sens.colHistory': "60 s",
  'sens.colRaw': "Xom",
  'sens.colSector': "Sektor",
  'sens.colTrend': "Trend",
  'sens.depthOnly': "chuqurlik",
  'sens.details': "Datchik tafsilotlari",
  'sens.eskin': "E-skin",
  'sens.estop': "Favqulodda to‘xtatish",
  'sens.frontLabel': "OLD · chuqurlik datchigi 72°",
  'sens.idleShort': "kutish",
  'lidar.layer': 'Lidar 360°',
  'lidar.layerTitle': "Robot lidari ko'rayotganini jonli ko'rsatish (devorlar nuqta, harakatlanayotganlar iz bilan)",
  'lidar.max': "Maks",
  'lidar.maxTitle': "Lidar ko'rgan eng uzoq nuqtaga moslash",
  'lidar.zoomIn': "Yaqinroq",
  'lidar.zoomOut': "Uzoqroq",
  'lidar.zoomHint': "Radar ustida g'ildirak bilan masshtabni o'zgartiring",
  'lidar.range': 'Masofa',
  'lidar.badge.live': 'LIVE {hz}',
  'lidar.badge.off': "o'chirilgan",
  'lidar.badge.connecting': 'ulanmoqda…',
  'lidar.badge.nodata': "ma'lumot yo'q",
  'lidar.badge.moving': 'robot yurmoqda',
  'lidar.card': 'Lidar jonli',
  'lidar.switchTitle': 'Bu robot lidarini saytga uzatish',
  'lidar.cardNote': "Robot lidar ma'lumotini faqat shu kalit yoqilgan va kimdir radarni ochgan paytda yuboradi. O'chirish bu robot uchun hamma uchun uzatishni to'xtatadi.",
  'lidar.rate': 'Chastota',
  'lidar.delay': 'Kechikish',
  'lidar.watching': 'Kuzatmoqda',
  'lidar.status.off': "O'chirilgan: hech narsa yuborilmaydi, radarda faqat boshqa qatlamlar.",
  'lidar.status.connecting': 'Birinchi skan kutilmoqda…',
  'lidar.status.live': 'Devorlar nuqta, harakatlanayotganlar iz bilan rangli nuqta.',
  'lidar.status.moving': 'Robot yurmoqda: faqat devorlar, harakatlanayotganlar robot turganda aniqlanadi.',
  'lidar.status.nodata': "Lidar ma'lumoti yo'q: robot oflayn, ilova eski yoki lidar jim.",
  'lidar.moving': 'Harakatlanayotgan obyektlar',
  'lidar.movingNote': '{n} · lidar',
  'lidar.colMotion': 'Harakat',
  'lidar.approaching': 'yaqinlashmoqda',
  'lidar.receding': 'uzoqlashmoqda',
  'lidar.stopped': '{s} s turibdi',
  'lidar.noObjects': 'Robot atrofida hech narsa harakatlanmayapti.',
  'lidar.caption': "Lidar · eng yaqini {d}",
  'lidar.captionNone': "Lidar · hech narsa ko'rinmayapti",
  'lidar.lgPoints': 'lidar nuqtalari (devor, mebel)',
  'lidar.lgTrail': 'iz, oxirgi 2 s',
  'lidar.toggle': 'Lidar',
  'lidar.toggleTitle': 'Mini-radarda lidar',
  'site.label': "Joy",
  'site.tabs': "Joylar",
  'site.robotSite': "Robot joyi",
  'site.none': "Joysiz",
  'site.noneShort': "Joysiz",
  'site.manage': "Joylar…",
  'site.manageShort': "Joylar…",
  'site.change': "Robot joyini o'zgartirish",
  'site.moveTo': "Joyga ko'chirish…",
  'site.moved': "{n} robot → {site}",
  'site.movedNone': "{n} robot endi joysiz",
  'site.title': "Joylar",
  'site.oneSiteNote': "Robot doim bitta joyda. Joyga bog'langan planshet (Admin → Kiosk accounts) faqat shu joy robotlarini ko'rsatadi.",
  'site.name': "Nomi",
  'site.color': "Rang",
  'site.robotsN': "{n} robot",
  'site.edit': "{name} ni tahrirlash",
  'site.delete': "{name} ni o'chirish",
  'site.deleteConfirm': "«{name}» joyini o'chirasizmi? Uning {n} roboti joysiz qoladi.",
  'site.empty': "Hozircha joylar yo'q.",
  'site.new': "Yangi joy",
  'site.newPlaceholder': "Masalan: Samarqand",
  'site.add': "Qo'shish",
  'site.allGroups': "Barcha guruhlar",
  'site.sectionCount': "{n} robot",
  'site.sectionOnline': "{n} onlayn",
  'site.onlyThis': "Faqat {site}",
  'site.allFrom': "«{site}» dan hammasi · {n}",
  'guard.barrier': "Signal · {d}",
  'guard.barrierOff': "qo'riqlash o'chiq",
  'guard.lgBarrier': "signal chegarasi (korpusdan)",
  'sens.lCamera': "Kameradagi odamlar",
  'sens.lDepth': "Chuqurlik yelpig‘ichi",
  'sens.lPresence': "Mavjudlik",
  'sens.lTracks': "Obyektlar",
  'sens.layers': "Qatlamlar",
  'sens.lblApproach': "↓ yaqinlashmoqda {v} m/s · {ttc} s",
  'sens.lblAway': "↑ uzoqlashmoqda {v} m/s",
  'sens.lblStatic': "· joyida",
  'sens.legend': "Shartli belgilar",
  'sens.lgAlertRing': "ogohlantirish chegarasi",
  'sens.lgHuman': "human_detect 1.3 m (yo‘nalishsiz)",
  'sens.lgNoData': "masofa ma’lumoti yo‘q",
  'sens.no': "yo‘q",
  'sens.noDirection': "yo‘nalishsiz",
  'sens.noPose': "joylashuv yo‘q",
  'sens.noSensorsDesc': "Robot status.sensors yubormaydi (eski ilova yoki emulyator)",
  'sens.noTracks': "Oldinda ishonchli hech narsa yo‘q",
  'sens.noTracksStale': "Yangi chuqurlik ma’lumoti yo‘q",
  'sens.object': "Obyekt",
  'sens.obstacle': "To‘siq",
  'sens.onChange': "o‘zgarganda",
  'sens.onEvent': "hodisa bo‘yicha",
  'sens.options': "Radar sozlamalari",
  'sens.pressed': "BOSILGAN",
  'sens.radar': "Yaqinlik radari",
  'sens.released': "bo‘sh",
  'sens.robotViews': "Robot bo‘limlari",
  'sens.safetyEvents': "Xavfsizlik hodisalari",
  'sens.sectorsNote': "Robotdan xom qiymatlar (sm; qo‘pol, kadrlar orasida miltillaydi). Sektor faqat oxirgi 5 tadan 3 tasi mos kelsa hisoblanadi; xira = past ishonch. ≥ 95 sm = uzoq. Orqa va yonlar: masofa ma’lumoti yo‘q (faqat robot navigatsiyasi).",
  'sens.sectorsTitle': "Old chuqurlik · 6 sektor",
  'sens.sideF': "oldida",
  'sens.sideL': "old chapda",
  'sens.sideR': "old o‘ngda",
  'sens.sources': "Jonli manbalar",
  'sens.srcCliff': "Jarlik (ha/yo‘q) · {s}",
  'sens.srcDepth': "Chuqurlik xulosasi · qo‘pol (~15 sm qadam), 1 Hz",
  'sens.srcHuman': "Mavjudlik ≤ 1.3 m · {s} · yo‘nalishsiz",
  'sens.srcObstacle': "To‘siq (ROS) · {s}",
  'sens.srcSkin': "Qo‘l teginish zonalari · {n} ta",
  'sens.staleDesc': "Oxirgi chuqurlik qiymati {age} · yelpig‘ich shtrixlangan, kuzatuv yo‘q",
  'sens.tabDrive': "Boshqaruv",
  'sens.tabSensors': "Datchiklar",
  'sens.toolbarNote': "faqat old yelpig‘ich · trend 1 Hz o‘lchovlardan",
  'sens.tracked': "Kuzatilayotgan obyektlar",
  'sens.trackedNote': "{n} · chuqurlik + kamera",
  'sens.trend.approaching': "↓ yaqinroq",
  'sens.trend.receding': "↑ uzoqroq",
  'sens.trend.static': "· joyida",
  'sens.units': "Birliklar",
  'sens.yes': "HA",
  'sens.yesAhead': "HA · oldinda",
  'sens.state.normal': "Oldinda bo‘sh",
  'sens.state.approaching': "Kimdir yaqinlashmoqda",
  'sens.state.tooClose': "Juda yaqin",
  'sens.state.cliff': "Jarlik aniqlandi",
  'sens.state.nodata': "Datchik ma’lumotlari yo‘q",
  'sens.state.charging': "Quvvatlanmoqda · datchiklar kutishda",
  'sens.radarToggle': "Radar",
  'sens.radarToggleTitle': "Kamera ustida mini-radarni ko‘rsatish",
  'sens.openSensors': "Datchiklar sahifasini ochish",
  'maps.layerSensors': "Datchiklar",
  'charge.allBusy': "Barcha quvvatlash nuqtalari band — keyinroq urinib ko‘ring",
  'charge.dockFailed': "Quvvatlashga ulanib bo‘lmadi (bosqich: {stage})",
  'charge.dockTried': "urinilgan: {list}",
  'fleet.chargeShort': 'Quvvat',
  'charge.dockTitleMany': "Eng yaqin bo‘sh ⚡ quvvatlash nuqtasiga boradi (xaritada: {n}), so‘ng stansiyaga ulanadi",
  'charge.occ.free': "bo‘sh",
  'charge.occ.occupied': "band",
  'charge.occ.occupiedBy': "band: {name}",
  'charge.occ.reserved': "band qilingan",
  'charge.occ.reservedBy': "zaxira: {name}",
  'charge.occ.unknown': "holati noma’lum",
  'charge.occ.thisRobot': "shu robot",
  'charge.countOnMap': "Xaritadagi quvvatlash nuqtalari: {n}",
  'charge.showOnMap': "Xaritada ko‘rsatish",
  'charge.chooseCharger': "Quvvatlash nuqtasini tanlash",
  'charge.nearestFree': "Eng yaqin bo‘sh",
  'charge.dockNearest': "Quvvatlash · eng yaqin bo‘sh",
  'charge.noChargersShort': "Bu xaritada ⚡ quvvatlash nuqtalari yo‘q",
  'charge.chargersTitle': "Quvvatlash nuqtalari",
  'charge.addCharger': "Quvvatlash nuqtasi",
  'charge.chargerIs': "Quvvatlash:",
  'charge.edit': "O‘zgartirish",
  'charge.newName': "Quvvatlash",
  'charge.clickHint': "Xaritada quvvatlash stansiyasidan ~0.5 m oldinga bosing, so‘ng strelkani stansiyaga buring",
  'drive.keysHint': "W A S D / strelkalar · W+D = ravon burilish",
  'drive.fwdLeftAria': "Oldinga va chapga (yoy)",
  'drive.fwdRightAria': "Oldinga va o‘ngga (yoy)",
  'drive.backLeftAria': "Orqaga va chapga (yoy)",
  'drive.backRightAria': "Orqaga va o‘ngga (yoy)",
  'hand.button': "Qo‘lda surish",
  'hand.title': "Xodim robotni surishi uchun g‘ildirak tormozlarini bo‘shatish",
  'hand.lock': "G‘ildiraklarni qulflash",
  'guard.title': "Robot qo‘riqlovi",
  'guard.short': "Qo‘riqlov",
  'guard.off': "Qo‘riqlov o‘chiq",
  'guard.turnOn': "Qo‘riqlovni yoqish",
  'guard.turnOff': "Qo‘riqlovni o‘chirish",
  'guard.distance': "Qo‘riqlov masofasi",
  'guard.distanceHint': "0,5–3,0 m: masofa kesib o‘tilganda ovozli ogohlantirish, bir soniyadan keyin sirena",
  'guard.closer': "Yaqinroq",
  'guard.farther': "Uzoqroq",
  'guard.pause': "15 daqiqa pauza",
  'guard.resume': "Davom ettirish",
  'guard.reset': "1,5 m ga qaytarish",
  'guard.hint': "Darhol qo‘llanadi; har bir o‘zgarish robot jurnaliga yoziladi.",
  'guard.lidarOk': "lidar ishlayapti",
  'guard.lidarNo': "lidar ma’lumoti yo‘q",
  'guard.ros': "ROS ulangan",
  'guard.rosDown': "ROS ulanmagan",
  'guard.state.watching': "Kuzatmoqda",
  'guard.state.learning': "atrofni o‘rganmoqda",
  'guard.state.moving': "Harakatda — lidar kutmoqda, qo‘lga tegish kuzatiladi",
  'guard.state.warn': "Ogohlantirish",
  'guard.state.alarm': "TREVOGA",
  'guard.state.touch': "Qo‘lga tegildi",
  'guard.state.paused': "{until} gacha pauza",
  'guard.state.blind': "Ko‘rmayapti (lidar ma’lumoti yo‘q)",
  'guard.fail': "Qo‘riqlov · {name}: {why}",
  'guard.failSilent': "Qo‘riqlov · {name} javob bermadi",
  'guard.whyUnsupported': "robot ilovasida qo‘riqlov yo‘q — APK ni yangilang",
  'hand.lockTitle': "G‘ildirak tormozlarini qayta yoqish",
  'hand.banner': "Qo‘lda surish rejimi — g‘ildiraklar bo‘shatilgan.",
  'hand.driveHint': "Qo‘lda surish rejimi yoqilgan — g‘ildiraklar qulflanmaguncha boshqarish o‘chirilgan. STOP ham ularni qulflaydi.",
  'hand.blocked': "qo‘lda surish rejimi yoqilgan — avval g‘ildiraklarni qulflang",
  'auto.home.toPoint': "O‘z joyiga qaytmoqda ({point})",
  'auto.home.back': "O‘z joyiga qaytmoqda",
  'auto.home.idle': "{s} s davomida faollik yo‘q",
  'auto.home.idleNoS': "faollik yo‘q",
  'auto.tabTranscript': "Transkript",
  'auto.tabControls': "Boshqaruv",
  'auto.liveControls': "Jonli boshqaruv",
  'auto.sessionNow': "Ushbu seans",
  'auto.controlsNote': "Bu o‘zgarishlar avtonomiyani to‘xtatmaydi",
  'auto.maxSpeedSession': "Maks. tezlik",
  'auto.turnSpeed': "Burilish tezligi",
  'auto.turnSpeedTip': "Robot qanchalik tez buriladi. U joyida buriladi, shuning uchun burilish radiusi yo‘q.",
  'auto.sessionLang': "Til",
  'auto.paramsApiMissing': "Avtonomiya paytida o‘zgartirish uchun yangiroq server kerak",
  'charge.title': "Avto-quvvatlash",
  'charge.enabled': "Avto-quvvatlash yoqilgan",
  'charge.low': "Quvvatlashga borish chegarasi",
  'charge.resume': "Davom ettirish",
  'charge.critical': "Kritik",
  'charge.criticalHint': "Bu darajada robot hamma narsani to‘xtatib, darhol quvvatlashga ketadi",
  'charge.resumeTask': "Quvvatlangandan keyin vazifani davom ettirish",
  'charge.save': "Saqlash",
  'charge.saved': "Avto-quvvatlash sozlamalari saqlandi",
  'charge.saveFailed': "Avto-quvvatlash sozlamalarini saqlab bo‘lmadi",
  'charge.apiMissing': "Avto-quvvatlash uchun yangiroq server kerak",
  'charge.noCharger': "«{map}» xaritasida ⚡ quvvatlash nuqtasi yo‘q — robot stansiyaga to‘g‘ridan-to‘g‘ri ulanadi.",
  'charge.openMap': "Xaritada belgilash",
  'charge.state.idle': "kutish",
  'charge.state.going': "quvvatlashga ketmoqda",
  'charge.state.charging': "quvvatlanmoqda",
  'charge.state.failed': "xato",
  'charge.lowToast': "Batareya {b}% — quvvatlashga ketmoqda",
  'charge.dockedToast': "quvvatlanmoqda ({b}%)",
  'charge.failedToast': "Quvvatlash stansiyasiga yetib bora olmadi",
  'charge.resumedToast': "{b}% gacha quvvatlandi — vazifani davom ettirmoqda",
  'charge.chip.going': "Quvvatlashga ketmoqda",
  'charge.chip.charging': "Quvvatlanmoqda",
  'charge.chip.failed': "Yetib bora olmadi",
  'charge.dockTitle': "Quvvatlash: xaritada ⚡ nuqta bo‘lsa, avval unga boradi, so‘ng stansiyaga ulanadi",
  'charge.dockTitleCharger': "⚡ «{name}» nuqtasiga boradi, so‘ng stansiyaga ulanadi",
  'charge.dockTitleNoCharger': "Bu xaritada ⚡ quvvatlash nuqtasi yo‘q — stansiyaga to‘g‘ridan-to‘g‘ri ulanadi",
  'charge.pointType': "Nuqta turi",
  'charge.kindNormal': "Oddiy",
  'charge.kindCharger': "Quvvatlash",
  'charge.kindTaken': "boshqa nuqtadan ko‘chadi",
  'charge.moveChargerConfirm': "«{from}» allaqachon ⚡ quvvatlash nuqtasi (xaritada bitta). ⚡ ni «{to}» ga ko‘chirasizmi?",
  'charge.placeHint': "Nuqtani quvvatlash stansiyasidan ~0.5 m oldinga, strelkasi stansiyaga qaratib qo‘ying",
  'charge.rotateHandle': "Yo‘nalishni belgilash uchun torting (Shift — erkin burchak)",
  'stuck.phase.detour': "aylanib o‘tmoqda",
  'stuck.phase.detour.left': "chap tomondan aylanib o‘tmoqda",
  'stuck.phase.detour.right': "o‘ng tomondan aylanib o‘tmoqda",
  'stuck.phase.detected': "to‘siq aniqlandi",
  'stuck.phase.announce': "yo‘l berishni so‘ramoqda",
  'stuck.phase.lookaround': "atrofga qaramoqda",
  'stuck.phase.replan': "boshqa yo‘l qidirmoqda",
  'stuck.phase.recovered': "yo‘l ochiq",
  'stuck.phase.failed': "uddalay olmadi",
  'stuck.banner': "To‘sildi — {phase} (urinish {a}/{m})",
  'stuck.failed': "Robot o‘ta olmayapti — yordam kerak",
  'stuck.failedAt': "x {x} · y {y} nuqtada",
  'stuck.goal': "{goal} tomon",
  'stuck.showOnMap': "Xaritada ko‘rsatish",
  'stuck.dismiss': "Yopish",
  'stuck.recoveredToast': "{name}: yo‘l ochiq, davom etmoqda",
  'stuck.failedToast': "{name} o‘ta olmayapti — yordam kerak",
  'stuck.openRobot': "Robotni ochish",
  'stuck.chip': "To‘sildi {a}/{m}",
  'stuck.chipFailed': "Qotib qoldi — yordam",
  'stuck.line': "⚠ To‘sildi — {phase} ({a}/{m})",
  'stuck.lineRecovered': "✓ Yo‘l ochiq",
  'stuck.lineFailed': "⛔ O‘ta olmadi — {a} urinishdan keyin to‘xtadi",
  'stuck.pointBadge': "qotib qolgan ×{n}",
  'stuck.pointBadgeTitle': "Robot yaqinda bu nuqtaga borishda {n} marta qotib qoldi",
  'reach.tight': "Devorga juda yaqin — robot eng yaqin yetib boriladigan joyga boradi",
  'reach.unreachable': "Yetib bo‘lmaydi: virtual devorlar / to‘siqlar bilan yopilgan",
  'reach.status.ok': "Yetib boriladi",
  'reach.status.tight': "Devorga juda yaqin",
  'reach.status.enclosed': "Virtual devorlar bilan yopilgan",
  'reach.status.blocked': "To‘siqlar bilan yopilgan",
  'reach.countUnreachable': "{n} ta yetib bo‘lmaydi",
  'reach.countTight': "{n} ta devor yonida",
  'reach.moveHere': "Nuqtani shu yerga ko‘chirish",
  'reach.clearance': "oraliq {m} m",
  'reach.pending': "Yetib borish saqlangandan keyin tekshiriladi",
  'reach.approach': "Eng yaqin yetib boriladigan joy",
  'reach.noApproach': "Yaqinda yetib boriladigan joy yo‘q — nuqtani ko‘chiring yoki devorlarni o‘zgartiring",
  'reach.warnUnreachable': "Yetib bo‘lmaydigan nuqtalar: {n}",
  'reach.warnTight': "Devor yonidagi nuqtalar: {n}",
  'reach.savedWarnings': "Ogohlantirishlar bilan saqlandi: {s}",
  'auto.bargeHint': 'Yuborish robotni to‘xtatadi',
  'auto.interrupted': 'to‘xtatildi',
  // §6.2 real walls (scan editor)
  'scan.modeAria': "Qaysi devorlar",
  'scan.modeVirtual': "Virtual · {n}",
  'scan.modeScan': "Haqiqiy (skan)",
  'scan.title': "Haqiqiy devorlar",
  'scan.revision': "{n}-versiya",
  'scan.editedByHand': "qo‘lda o‘zgartirilgan",
  'scan.originalScan': "asl skan",
  'scan.modifiedTag': "Skan qo‘lda o‘zgartirilgan",
  'scan.help': "Robot yo‘lni skanerlangan xarita bo‘yicha tuzadi.",
  'scan.helpPencil': "{b} lazer ko‘rmaydigan narsalarni chizing: shisha, o‘tish joylari, to‘siqlar.",
  'scan.helpPencilB': "Qalam bilan",
  'scan.helpEraser': "{b} skandagi keraksiz narsalarni o‘chiring: odamlar, stullar, qutilar.",
  'scan.helpEraserB': "O‘chirg‘ich bilan",
  'scan.warn': "Haqiqiy devorlarni o‘chirmang: robot ular orqali qayerdaligini aniqlaydi. Chizilgan devorni lazer ko‘rmaydi — u faqat yo‘lni to‘sadi.",
  'scan.hand': "Qo‘l",
  'scan.pencil': "Qalam",
  'scan.pencilSub': "Devor chizish",
  'scan.eraser': "O‘chirg‘ich",
  'scan.eraserSub': "Keraksizini o‘chirish",
  'scan.toolbar': "Skanni tahrirlash vositalari",
  'scan.width': "Qalinlik",
  'scan.cm': "{n} sm",
  'scan.m': "{n} m",
  'scan.undo': "Ortga qaytarish",
  'scan.redo': "Qaytadan bajarish",
  'scan.original': "Asl skan",
  'scan.originalTitle': "Asl skanni tahrirlarsiz ko‘rsatish",
  'scan.originalPill': "Asl skan · tahrirlar yashirilgan",
  'scan.originalFailed': "Asl skan mavjud emas",
  'scan.showOriginal': "Asl skanni ko‘rsatish (tahrirlarsiz)",
  'scan.hintPencil': "Qalam: xarita bo‘ylab suring — devor chiziladi · Shift — to‘g‘ri chiziq · Ctrl/⌘+Z — ortga qaytarish · g‘ildirakcha — masshtab",
  'scan.hintEraser': "O‘chirg‘ich: suring — skandagi to‘siqlarni o‘chiradi (odamlar, stullar, qutilar) · Ctrl/⌘+Z — ortga qaytarish · g‘ildirakcha — masshtab",
  'scan.hintPan': "Qo‘l: xaritani suring, g‘ildirakcha — masshtab · probelni bosib turing — istalgan vositada vaqtincha qo‘l",
  'scan.legend': "Belgilar",
  'scan.legendWall': "Yangi devor · saqlanmagan",
  'scan.legendErase': "O‘chirilgan · saqlanmagan",
  'scan.legendVirtual': "Virtual devor (bu yerda o‘zgarmaydi)",
  'scan.pending': "Saqlanmagan tahrirlar: {n}",
  'scan.statWall': "+ {m} m devor",
  'scan.statErase': "{m} m² o‘chirildi",
  'scan.reset': "Asl skanni qaytarish",
  'scan.resetHelp': "Bu xaritaning barcha saqlangan skan tahrirlarini o‘chiradi. Virtual devorlar va nuqtalarga tegmaydi.",
  'scan.resetConfirm': "Asl skan qaytarilsinmi? Bu xaritaning barcha saqlangan skan tahrirlari o‘chiriladi. Virtual devorlar va nuqtalar o‘zgarmaydi.",
  'scan.resetConfirmPending': "Saqlanmagan tahrirlar ({n}) ham yo‘qoladi.",
  'scan.resetDone': "Asl skan tiklandi",
  'scan.resetFailed': "Asl skanni qaytarib bo‘lmadi",
  'scan.save': "Xaritani saqlash *",
  'scan.saving': "Saqlanmoqda…",
  'scan.noChanges': "O‘zgarishlar yo‘q",
  'scan.savedButton': "Xarita saqlandi",
  'scan.savedNotice': "Xarita saqlandi · {n}-versiya",
  'scan.outdatedOne': "{name} hali eski versiya bo‘yicha yuryapti. Robot tahrirlarni olishi uchun xaritani o‘rnating.",
  'scan.outdatedMany': "{list} hali eski versiya bo‘yicha yuryapti. Robotlar tahrirlarni olishi uchun xaritani o‘rnating.",
  'scan.noOutdated': "Bu xarita hali hech bir robotga o‘rnatilmagan.",
  'scan.deploy': "Robotlarga o‘rnatish",
  'scan.dismiss': "Yashirish",
  'scan.savedToast': "Xarita saqlandi — tahrirlarni qo‘llash uchun uni robotlarga o‘rnating",
  'scan.saveFailed': "Xaritani saqlab bo‘lmadi",
  'scan.saveError': "Xaritani saqlab bo‘lmadi: {reason}. Tahrirlar ekranda qoldi — qayta urinib ko‘ring.",
  'scan.noResponse': "server javob bermadi",
  'scan.apiMissing': "Skanni tahrirlash bu serverda hali mavjud emas (PROTOCOL §6.2 endpointlari yo‘q). Tahrirlar sahifadan chiqmaguningizcha shu yerda qoladi.",
  'scan.limit': "Bu xaritada skan tahrirlari juda ko‘p: jami ko‘pi bilan {strokes} ta chiziq va {coords} ta koordinata.",
  'scan.switchConfirm': "Saqlanmagan skan tahrirlari ({n}) yo‘qoladi. Baribir almashtirilsinmi?",
  'scan.saveBeforeDeploy': "Skanda saqlanmagan tahrirlar bor. O‘rnatishdan oldin saqlansinmi?",
  // §6.3 yetib borishga nima xalaqit beradi
  'access.tab': "Yetib borish",
  'access.badge': "Yetib bo‘lmaydi: {n}",
  'access.heading.one': "{n} ta nuqtaga yetib bo‘lmaydi",
  'access.heading.few': "{n} ta nuqtaga yetib bo‘lmaydi",
  'access.heading.many': "{n} ta nuqtaga yetib bo‘lmaydi",
  'access.allOk': "Barcha nuqtalarga yetib boriladi",
  'access.help': "Robotga kamida {w} m kenglikdagi o‘tish joyi kerak: har tomonda devorlardan {c} m. Quyida yo‘lni aynan nima to‘sayotgani — eng ko‘p xalaqit beradiganidan boshlab.",
  'access.showOnMap': "Xaritada ko‘rsatish",
  'access.chip': "Yetib borishga nima xalaqit beradi",
  'access.narrow': "Tor o‘tish joyi",
  'access.narrowAt': "«{name}» yonida tor o‘tish joyi",
  'access.narrowZone': "«{name}» zonasiga tor o‘tish joyi",
  'access.narrowTo': "«{name}» ga tor o‘tish joyi",
  'access.narrowToMore': "«{name}» va yana {n} ta nuqtaga tor o‘tish joyi",
  'access.realTo': "«{name}» yo‘lidagi skan devori",
  'access.realToMore': "«{name}» va yana {n} ta nuqta yo‘lidagi skan devori",
  'access.virtual': "{n}-virtual devor",
  'access.real': "Skan devori",
  'access.realAt': "«{name}» yonidagi skan devori",
  'access.blocks.one': "{n} ta nuqtaga xalaqit beradi",
  'access.blocks.few': "{n} ta nuqtaga xalaqit beradi",
  'access.blocks.many': "{n} ta nuqtaga xalaqit beradi",
  'access.passage': "o‘tish joyi ≈ {w} m",
  'access.kindVirtual': "virtual devor",
  'access.kindReal': "skan devori",
  'access.helpNarrow': "Skan devorlari orasida {w} m dan kam joy bor. Agar o‘tish joyida skan chiqindisi bo‘lsa (odamlar, stullar) — uni o‘chirg‘ich bilan o‘chiring. Agar o‘tish joyi haqiqiy bo‘lsa, robot u yerdan o‘ta olmaydi.",
  'access.helpVirtual': "Robot hech qachon virtual devorlarni kesib o‘tmaydi. Bu yerda yurish mumkin bo‘lsa, uni olib tashlang yoki suring.",
  'access.helpReal': "Yo‘lni skan devori to‘sib turibdi. Agar bu haqiqiy devor bo‘lmasa (skanerlashda eshik yopiq bo‘lgan, chiqindi), uni o‘chirg‘ich bilan o‘chiring.",
  'access.pointsList': "Nuqtalar: {list}",
  'access.show': "Xaritada ko‘rsatish",
  'access.fixErase': "O‘chirg‘ichni shu yerda ochish",
  'access.fixWall': "Devorni o‘zgartirish",
  'access.computing': "Hisoblanmoqda…",
  'access.noBlockers': "Server ularga aynan nima xalaqit berayotganini aniqlay olmadi.",
  'access.apiMissing': "Bu server hali nima xalaqit berayotganini topa olmaydi (PROTOCOL §6.3 endpointi yo‘q). Yetib bo‘lmaydigan nuqtalar xaritada baribir belgilangan.",
  'access.loadFailed': "Nima xalaqit berayotganini yuklab bo‘lmadi: {msg}",
  'access.markerVirtual': "№{k} · {n}",
  'access.markerReal': "Skan devori · {n}",
  'access.passageVV': "{a} va {b}-virtual devorlar orasidagi o‘tish joyi ≈ {w} m",
  'access.passageRV': "skan devori va {a}-virtual devor orasidagi o‘tish joyi ≈ {w} m",
  'access.passageV1': "{a}-virtual devor qismlari orasidagi o‘tish joyi ≈ {w} m",
  'access.passageRR': "skan devorlari orasidagi o‘tish joyi ≈ {w} m",
  'access.fixWallN': "{n}-devorni o‘zgartirish",
  'access.helpNarrowVirtual': "O‘tish joyi kamida {w} m bo‘lishi uchun bu devorlarni bir-biridan uzoqlashtiring.",
  'access.helpNarrowOneWall': "O‘tish joyi kamida {w} m bo‘lishi uchun {n}-virtual devorni o‘zgartiring.",
  'access.helpNarrowMixed': "O‘tish joyi kamida {w} m bo‘lishi uchun {n}-virtual devorni skan devoridan uzoqlashtiring. Agar skan devori chiqindi bo‘lsa (odamlar, stullar), uni o‘chirg‘ich bilan o‘chiring.",
  'access.legend': "Belgilar",
  'access.legendNarrow': "Tor o‘tish joyi: {w} m dan tor",
  'access.legendWall': "Yo‘ldagi virtual devor",
  'access.legendPath': "Robot o‘ta olmaydigan joy",
  'access.legendPoint': "Yetib bo‘lmaydigan nuqta",
  'maps.saving': "Saqlanmoqda…",
  // nuqtalarni tavsiya etilgan joylarga ko‘chirish (Nuqtalar bo‘limi)
  'bulk.hintTitle': "Devorga juda yaqin nuqtalar: {n}",
  'bulk.hintText': "Robot bunday nuqtaning aynan ustida to‘xtay olmaydi va yonida to‘xtaydi. Ularni tavsiya etilgan joylarga — devordan {m} m uzoqlikka ko‘chiring.",
  'bulk.hintButton': "Hammasini tavsiya etilgan joylarga ko‘chirish…",
  'bulk.hintHide': "Maslahatni yashirish",
  'bulk.linkTitle': "Tavsiya etilgan joylarga ko‘chirish",
  'bulk.pointLink': "Bunday nuqtalarning hammasini ko‘chirish ({n})…",
  'bulk.toastAction': "Ko‘chirish ({n})",
  'bulk.back': "Nuqtalar",
  'bulk.title': "Nuqtalarni devorlardan uzoqlashtirish",
  'bulk.text': "Har bir nuqta devordan kamida {m} m uzoqdagi eng yaqin joyga ko‘chadi — robot u yerga borib, aynan ustida to‘xtaydi. Nuqta 1 m dan uzoqqa va devor orqali ko‘chmaydi.",
  'bulk.selected': "Tanlangan: {on} / {all}",
  'bulk.shift': "siljish {a}–{b} m",
  'bulk.turn': "Eski joyga — eksponatga qaratish",
  'bulk.turnHint': "Faqat yo‘nalishi yo‘q nuqtalarga ({n}). Belgilangan yo‘nalish o‘zgarmaydi.",
  'bulk.all': "Hammasi",
  'bulk.sortHint': "siljish bo‘yicha ↓ · bosing — xaritada ko‘rsatish",
  'bulk.row': "oraliq {c} m → siljish {s} m",
  'bulk.rowAria': "{n} · {name} ni ko‘chirish",
  'bulk.enclosedNote': "Virtual devorlar ortidagi nuqtalarni bu usulda tuzatib bo‘lmaydi — ular uchun «Yetib borish» bo‘limi.",
  'bulk.cancel': "Bekor qilish",
  'bulk.apply': "Ko‘chirish va saqlash · {n}",
  'bulk.empty': "Devor yonida nuqtalar yo‘q",
  'bulk.previewChip': "Oldindan ko‘rish — nuqtalar hali eski joylarida",
  'bulk.legend': "Belgilar",
  'bulk.legendNow': "Nuqta hozir — devorga juda yaqin",
  'bulk.legendSpot': "Tavsiya etilgan joy (devordan {m} m)",
  'bulk.legendFace': "Robot qayerga qaraydi (eski joyga)",
  'bulk.doneTitle': "Ko‘chirildi va saqlandi: {n} ta nuqta",
  'bulk.doneAllOk': "Barcha nuqtalarga yetib boriladi.",
  'bulk.doneLeft': "Hali devor yonida: {n}.",
  'bulk.doneFacing': "Har biri eski joyiga — eksponatga qaragan.",
  'bulk.undo': "Avvalgi holatga qaytarish",
  'bulk.hide': "Yashirish",
  'bulk.doneToast': "Ko‘chirildi va saqlandi: {n} ta nuqta",
  'bulk.toastUndo': "Bekor qilish",
  'bulk.undone': "Eski joyiga qaytarildi: {n} ta nuqta",
  'bulk.undoSkipped': "Tegilmadi (siz ularni o‘zgartirgansiz): {k}",
  'maps.allPoints': 'Barcha nuqtalar',
  'maps.pointPos': '{i} / {n}',
  'maps.prevPoint': 'Oldingi nuqta',
  'maps.nextPoint': 'Keyingi nuqta',
  'maps.filterAll': 'Hammasi · {n}',
  'maps.filterLabel': 'Nuqtalar filtri',
  'charge.addShort': 'Quvvatlash',
  'tours.allTours': 'Barcha turlar',
  'tours.tabStops': 'Bekatlar · {n}',
  'tours.tabSettings': 'Sozlamalar',
  'tours.tabRobots': 'Robotlar · {n}',
  'tours.findStop': 'Bekatni topish',
  'tours.addStopShort': '+ Bekat',
  'tours.noStops': 'Hali bekat yo‘q: «+ Bekat» bilan nuqta qo‘shing.',
  'tours.stopSettings': 'Bekat sozlamalari: {name}',
  'tours.toursCount': 'Bu xaritada {n} ta',
  'facing.bulkTitle': 'Yo‘nalishsiz {n} ta nuqtaga yo‘nalish berish',
  'facing.bulkPresets': 'Tez tanlash',
  'facing.bulkHint': 'Yo‘nalishi bor nuqtalar o‘zgarmaydi. Xaritada darhol ko‘rinadi, «Nuqtalarni saqlash» bilan saqlanadi.',
  'facing.bulkApply': '{n} ta nuqtani burish',
  'facing.bulkDone': '{n} ta nuqta {deg}° ga burildi. Nuqtalarni saqlashni unutmang.',
  'nav.updates': 'Yangilanish',
  'upd.title': 'Robot ilovasi yangilanishlari',
  'upd.auto': 'Robotlarni avtoyangilash',
  'upd.new': 'Yangi versiya',
  'upd.drop': 'Robot APK faylini shu yerga tashlang',
  'upd.choose': 'Faylni tanlash',
  'upd.other': 'Boshqa fayl',
  'upd.uploading': 'Yuklanmoqda va tekshirilmoqda… {pct}%',
  'upd.checked': '{size} · tekshirildi',
  'upd.version': 'Versiya',
  'upd.codeOf': 'kod {code} (robotlarda {fleet})',
  'upd.signature': 'Imzo',
  'upd.sigSame': 'o\'rnatilgan ilova bilan bir xil',
  'upd.sigUnknown': 'tekshirilmadi',
  'upd.notes': 'Nima yangi (versiyalar ro\'yxatida ko\'rinadi)',
  'upd.to': 'Kimga',
  'upd.toAll': 'Barcha robotlar · {n}',
  'upd.toSite': 'Maydon',
  'upd.toRobots': 'Robotlarni tanlash…',
  'upd.toRobotsN': 'Robotlar · {n}',
  'upd.pickTitle': 'Robotlarni tanlash',
  'upd.done': 'Tayyor',
  'upd.idleOnly': 'Faqat bo\'sh paytda',
  'upd.idleOnlyHint': '— tur, harakat, qo\'riqlash signali yoki suhbat paytida emas',
  'upd.canary': 'Avval bitta robot',
  'upd.canaryHint': 'qolganlari u yangi versiya bilan ulangandan keyin',
  'upd.publish': '{v} ni chiqarish',
  'upd.published': '{v} versiyasi chiqarildi',
  'upd.versions': 'Versiyalar',
  'upd.noVersions': 'Hali yuklangan versiyalar yo\'q',
  'upd.onRobots': '{n} ta robotda',
  'upd.rollingOut': 'chiqarilmoqda · {done}/{total}',
  'upd.notPublished': 'chiqarilmagan',
  'upd.delete': 'O\'chirish',
  'upd.deleteConfirm': '{v} versiyasini o\'chirish?',
  'upd.rollout': '{v} chiqarilishi',
  'upd.progress': '{total} tadan {done} tasi yangilandi',
  'upd.progressTap': '{n} tasi bosishni kutmoqda',
  'upd.pause': 'Chiqarishni to\'xtatish',
  'upd.resume': 'Chiqarishni davom ettirish',
  'upd.pausedTag': 'to\'xtatilgan',
  'upd.noRollout': 'Hozir hech narsa chiqarilmayapti. APK yuklang va «Chiqarish» tugmasini bosing.',
  'upd.fAll': 'Hammasi · {n}',
  'upd.fIdle': 'Bo\'sh vaqtni kutmoqda · {n}',
  'upd.fTap': 'Bosishni kutmoqda · {n}',
  'upd.fProblems': 'Muammolar · {n}',
  'upd.fOffline': 'Oflayn · {n}',
  'upd.colRobot': 'Robot',
  'upd.colSite': 'Maydon',
  'upd.colVersion': 'Versiya',
  'upd.colState': 'Holat',
  'upd.s.done': 'Yangilandi',
  'upd.s.canary': 'sinov roboti',
  'upd.s.offline': 'Oflayn · ulanganda yangilanadi',
  'upd.s.manual': 'Avtoyangilashsiz eski ilova',
  'upd.s.manualHint': 'bu versiyani bir marta qo\'lda o\'rnating',
  'upd.s.paused': 'Chiqarish to\'xtatilgan',
  'upd.s.waiting_canary': 'Sinov robotini kutmoqda',
  'upd.s.pending': 'Taklif yuborildi',
  'upd.s.downloading': 'Yuklab olmoqda',
  'upd.s.failed': 'Xato',
  'upd.s.unknown_sources': 'Noma\'lum manbalar o\'chiq',
  'upd.s.unknownHint': 'bir marta: Sozlamalar → Xavfsizlik → yoqish',
  'upd.s.waiting_idle': 'Bo\'sh vaqtni kutmoqda',
  'upd.s.snoozed': 'Yuklandi · «Keyinroq» bosildi',
  'upd.s.prompt': 'Robotda bosishni kutmoqda',
  'upd.s.promptAt': '«O\'rnatish» kartasi {time} da ko\'rsatildi',
  'upd.s.installer': 'Android o\'rnatish oynasi ochiq',
  'upd.s.installerHint': 'u yerda «O\'rnatish» ni bosing',
  'upd.busy.tour': '«{name}» turi · {total} tadan {step}-nuqta',
  'upd.busy.tourShort': 'tur davom etmoqda',
  'upd.busy.moving': 'robot harakatda',
  'upd.busy.talking': 'tashrif buyuruvchi bilan gaplashmoqda',
  'upd.busy.media': 'media ko\'rsatmoqda',
  'upd.busy.guard': 'qo\'riqlash signali',
  'upd.showNow': 'Hozir ko\'rsatish',
  'upd.showAgain': 'Yana ko\'rsatish',
  'upd.retry': 'Qayta urinish',
  'upd.footer': 'Robotlar chiqarilish haqida darhol bilib oladi va faylni o\'zi yuklab, nazorat summasini tekshiradi. O\'rnatishni robot ekranida odam tasdiqlaydi: «O\'rnatish», so\'ng Android oynasida yana «O\'rnatish». Eski versiyani faqat kattaroq versiya kodi bilan qayta yig\'ib qaytarish mumkin.',
  'upd.err.NOT_APK': 'Bu APK emas',
  'upd.err.NOT_APKHint': 'Faylda AndroidManifest.xml yo\'q.',
  'upd.err.NOT_NEWER': 'Versiya yangiroq emas',
  'upd.err.NOT_NEWERHint': 'Faylda kod {code}, robotlarda allaqachon {fleet}. versionCode ni oshirib, qayta yig\'ing.',
  'upd.err.CERT_MISMATCH': 'Boshqa imzo',
  'upd.err.CERT_MISMATCHHint': 'Android bu faylni o\'rnatilgan ilova ustiga o\'rnatmaydi. Oldingi versiyalar bilan bir xil kalit bilan yig\'ing.',
  'upd.err.WRONG_PACKAGE': 'Robot ilovasi emas',
  'upd.err.WRONG_PACKAGEHint': 'Bu {package}. {expected} kerak.',
  'upd.chip.version': 'App {v}',
  'upd.chip.available': '{v} mavjud',
  'upd.chip.downloading': 'Yuklab olmoqda {pct}%',
  'upd.chip.waitingIdle': 'Bo\'sh vaqtni kutmoqda',
  'upd.chip.tap': 'Robotda bosishni kutmoqda',
  'upd.chip.unknownSources': 'Noma\'lum manbalar o\'chiq',
  'upd.chip.failed': 'Yangilash xatosi',
};
